import {useTranslation} from "react-i18next";
import {DisplayImage} from "../../image/display/DisplayImage";
import {InfoLabel} from "../../../productConfiguration/inputs/InfoLabel";
import {MediaQueryTypes, useMediaQuery} from "../../../app/hooks";


export const BankInformation = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(MediaQueryTypes.IS_MOBILE);
    const imageName = !isMobile 
        ? 'BankLineDescription'
        : 'BankLineDescription-Mobile';
    
    return (
        <span className="d-flex flex-column text-center mb-4">
            <DisplayImage imageName={imageName}></DisplayImage>
            <InfoLabel>{t('bank.information.bottomBannerText')}</InfoLabel>
        </span>
    )
}
